import { render, staticRenderFns } from "./MemoForm.vue?vue&type=template&id=31c00a08&"
import script from "./MemoForm.vue?vue&type=script&lang=js&"
export * from "./MemoForm.vue?vue&type=script&lang=js&"
import style0 from "./MemoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports